import React from 'react';
import { Row, Col, FormFeedback } from 'reactstrap';
import InputField from "../Utils/InputField";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";

const renderFormFields = (fields, values, errors, touched, handleChange, setFieldValue, isEdit) => {
  return (
    <Row className="mb-3">
      {fields.map((field, index) => {
        const isInvalid = touched[field.name] && errors[field.name];
        switch (field.type) {
          case 'text':
            return (
              <Col lg={4} key={index} className="mb-3">
                <LabelText
                  htmlFor={field.name}
                  classLabelName={"ms-0 rv-form-label"}
                  className={"text-danger"}
                  displayText={field.label}
                  important="*"
                />
                <LabelText
                  htmlFor={field.name}
                  classLabelName={`d-block ms-0 rv-sub-label ${isInvalid
                    ? "rv-label-danger"
                    : "rv-label-muted"
                    } `}
                  displayText={field.placeholder}
                />
                <InputField
                  name={field.name}
                  type={field.type}
                  className={"form-control"}
                  id={field.name}
                  handleChange={handleChange}
                  value={values[field.name]}
                  invalid={isInvalid}
                  disabled={field.disabled}
                />
              </Col>
            );

          case 'select':
            return (
              <Col lg={4} key={index} className="mb-3">
                <LabelText
                  htmlFor={field.name}
                  classLabelName={"ms-0 rv-form-label"}
                  className={"text-danger"}
                  displayText={field.label}
                  important="*"
                />
                <LabelText
                  htmlFor={field.name}
                  classLabelName={`d-block ms-0 rv-sub-label ${isInvalid
                    ? "rv-label-danger"
                    : "rv-label-muted"
                    } `}
                  displayText={field.placeholder}
                />
                <SelectField
                  className={isInvalid ? "error-input" : ""}
                  value={values[field.name]}
                  placeholder={" "}
                  handleChange={(selectedOption) => {
                    setFieldValue(field.name, selectedOption);
                    setFieldValue('unitofmeasurement', selectedOption.unitofmeasurement || '');
                  }}
                  options={field.options}
                  isRVStyle={true}
                  isDisabled={isEdit}
                />
              </Col>
            );
          default:
            return null;
        }
      })}
    </Row>
  );
};
export function PolicyForm({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  schema,
  isEdit
}) {
  return (
    <>
      {renderFormFields(schema.fields, values, errors, touched, handleChange, setFieldValue, isEdit)}
    </>
  );
}
